var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "auth-file-dialog",
          attrs: {
            title: "重要事项提醒",
            visible: _vm.basicCaAuthFileDialogVisible,
            width: "520px",
            "append-to-body": "",
            "close-on-click-modal": false,
            "show-close": false,
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.basicCaAuthFileDialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "auth-file-content" }, [
            _c("p", [_vm._v("1、请打印《企业授权书》并盖章，提供PDF或图片")]),
            _c("p", [
              _vm._v("2、请保证授权书中"),
              _c("span", { staticClass: "red" }, [
                _vm._v("被授权人与当前操作人")
              ]),
              _vm._v("保持一致以免认证失败")
            ]),
            _c(
              "a",
              {
                staticClass: "auth-file-download",
                attrs: {
                  href: _vm.basicCaAuthFileTemplateUrl,
                  target: "_blank"
                }
              },
              [_vm._v("点击下载《企业授权书》模版")]
            )
          ]),
          _c(
            "div",
            {
              staticClass: "auth-file-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "medium", type: "danger" },
                  on: { click: _vm.onBasicCaAuthFileReady }
                },
                [_vm._v("已准备好")]
              ),
              _c("div", { staticClass: "mar10-t" }, [
                _c(
                  "a",
                  {
                    staticClass: "red",
                    attrs: { href: "javascript:;" },
                    on: {
                      click: function($event) {
                        _vm.basicCaAuthFileDialogVisible = false
                        _vm.basicCaChecked = false
                      }
                    }
                  },
                  [_vm._v("取消")]
                )
              ])
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "contract-preview",
          attrs: {
            visible: _vm.localVisible,
            title: "合同",
            fullscreen: "",
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.localVisible = $event
            }
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function() {
                return [
                  _c(
                    "div",
                    { staticClass: "text-center" },
                    [
                      _vm.basicCaAgreementUrl
                        ? _c(
                            "div",
                            { staticClass: "mar10-b" },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  on: { change: _vm.onBasicCaCheckedChange },
                                  model: {
                                    value: _vm.basicCaChecked,
                                    callback: function($$v) {
                                      _vm.basicCaChecked = $$v
                                    },
                                    expression: "basicCaChecked"
                                  }
                                },
                                [
                                  _vm._v("\n            我已阅读并同意"),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "red pointer",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.openBasicCaAgreement(
                                            $event
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "《" +
                                          _vm._s(_vm.basicCaAgreementName) +
                                          "》"
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.localVisible = false
                            }
                          }
                        },
                        [_vm._v("返回")]
                      ),
                      _vm.type == "sign"
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.onConfirm }
                            },
                            [_vm._v("我已阅读并同意签署")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("div", { staticClass: "h100-full" }, [
            _c("iframe", {
              attrs: {
                src: _vm.url,
                frameborder: "0",
                width: "100%",
                height: "100%"
              }
            })
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }